import isNull from 'lodash/isNull'
import { call, select, takeEvery } from 'redux-saga/effects'

import { isNonAreaJoistLine } from '../../../utils/project/project-helper-functions'
import managers from '../../lib/managers'
import PaperManager from '../../lib/managers/PaperManager'
import { Workspace } from '../../lib/toolBoxes/2D'
import { selectDrawableLocations } from '../../slices/2D'
import {
    GeometryVisibilityRecord,
    selectActiveGeometryGroupId,
    selectGeometryVisibilityRecord,
    toggleGeometriesVisibility,
} from '../../slices/geometry'
import { selectIsConflictResolutionInProgress } from '../../slices/masterSetPlan'
import { IMUP2DDrawableLocation } from '../../types'

export function* handleGeometriesVisibilityChange({ payload }: ReturnType<typeof toggleGeometriesVisibility>) {
    const manager: PaperManager | null = yield call(managers.get2DManager)

    if (isNull(manager)) return

    const workspaceTool: Workspace = yield call(manager.getTool, Workspace.NAME)
    const geoVisRecord: GeometryVisibilityRecord = yield select(selectGeometryVisibilityRecord)
    const activeGeometryGroupId: number | null = yield select(selectActiveGeometryGroupId)
    const drawableLocations: IMUP2DDrawableLocation[] = yield select(selectDrawableLocations)

    const { openingLocationIds, locIdToDrawableId } = drawableLocations.reduce(
        (idsAndRecord, loc) => {
            if (payload.includes(loc.drawable_id)) {
                return {
                    openingLocationIds: [...idsAndRecord.openingLocationIds, loc.opening_location_id],
                    locIdToDrawableId: {
                        ...idsAndRecord.locIdToDrawableId,
                        [loc.opening_location_id]: loc.drawable_id,
                    },
                }
            }

            return idsAndRecord
        },
        {
            openingLocationIds: [],
            locIdToDrawableId: {},
        } as {
            openingLocationIds: number[]
            locIdToDrawableId: Record<number, number>
        }
    )

    const items: paper.Item[] = yield call(workspaceTool.getItemsWithCriteria, 'data', (data) => {
        const modData = data.materialModificationConflict

        return openingLocationIds.includes(!modData ? data.opening_location_id : modData.material_location_id)
    })
    const isConflictResolutionInProgress: boolean = yield select(selectIsConflictResolutionInProgress)

    items.forEach((item) => {
        const modData = item.data.materialModificationConflict

        if (isConflictResolutionInProgress && !modData && !item.data.createdDuringConflictResolution) {
            item.visible = false

            return
        }

        const drawableId = locIdToDrawableId[!modData ? item.data.opening_location_id : modData.material_location_id]
        const newVisStatus = geoVisRecord[drawableId] ?? true
        const isJoistLineItem = isNonAreaJoistLine(item)

        // if it is a non joist line item or the new status is to hide then hide
        // if it is a joist line and we should show it, only show it if it is
        // the active group
        item.visible =
            ((!isJoistLineItem || !newVisStatus) && newVisStatus) ||
            (isJoistLineItem && newVisStatus && item.data.opening_group_id === activeGeometryGroupId)
    })
}

export function* watchForGeometriesVisibilityChange() {
    yield takeEvery(toggleGeometriesVisibility, handleGeometriesVisibilityChange)
}
